module.exports = __webpack_public_path__ + "images/file_icons_v2/jpg-6681834a67b0dece39947c0566b824e1.svg";